import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IAppState {
  shownInquiryModal: boolean;
}

const initialState: IAppState = {
  shownInquiryModal: false,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setShownInquiryModal: (state, action: PayloadAction<boolean>) => {
      state.shownInquiryModal = action.payload;
    },
  },
});

export const { setShownInquiryModal } = appSlice.actions;
export default appSlice.reducer;
